export function recoverPasswordForPhoneRequest(vl_full_phone_number, from_educa) {
	return {
		type: "@recover/RECOVER_PASSWORD_FOR_PHONE_REQUEST",
		payload: { vl_full_phone_number, from_educa },
	};
}

export function recoverPasswordForPhoneSuccess(vl_full_phone_number) {
	return {
		type: "@recover/RECOVER_PASSWORD_FOR_PHONE_SUCCESS",
		payload: { vl_full_phone_number },
	};
}

export function recoverPasswordForPhoneFail() {
	return {
		type: "@recover/RECOVER_PASSWORD_FOR_PHONE_FAIL",
	};
}

export function changeLoading(loading) {
	return {
		type: "@recover/CHANGE_LOADING",
		payload: {
			loading,
		},
	};
}

// vlDocument = Cpf digitado;
// documentType = CPF;
// recoveryInfoType = "phone_mobile" OU "email";
// recoveryInfo = Valor do input entre email e numero do telefone;
// operatingSystem = null
// documentType = CPF
export function requestAccountRecoverWithType(
	vlDocument,
	documentType,
	recoveryInfoType,
	recoveryInfo,
	operatingSystem,
	header
) {
	return {
		type: "@recover/REQUEST_ACCOUNT_RECOVER_WITH_TYPE",
		payload: { vlDocument, documentType, recoveryInfoType, recoveryInfo, operatingSystem, header },
	};
}

export function respAccountRecoverWithType(data) {
	return {
		type: "@recover/RESP_ACCOUNT_RECOVER_WITH_TYPE",
		payload: { data },
	};
}

export function showMessageRecoverFailed(error, obj) {
	return {
		type: "@recover/SHOW_MESSAGE_RECOVER_FAILED",
		payload: { error, ...obj },
	};
}

// token = Token digitado pelo Usuario;
// type = "phone_mobile" OU "email";
// value = valor do teleqfone ou email;
export function doRecoverAccountWithType(token, type, value, vlDocument) {
	return {
		type: "@recover/DO_RECOVER_ACOUNT_WITH_TYPE",
		payload: { token, type, value, vlDocument },
	};
}

export function recoverPinCodeFailed(param) {
	return {
		type: "@recover/RECOVER_PIN_CODE_FAILED",
		payload: { param },
	};
}

export function changePasswordAfterValidate(token, newPassword, newConfirmPassword) {
	return {
		type: "@recover/CHANGE_PASSWORD_AFTER_VALIDATE",
		payload: { token, newPassword, newConfirmPassword },
	};
}

export function sendToken(token) {
	return {
		type: "@recover/SEND_TOKEN",
		payload: { token },
	};
}
